import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';

import { InitialService } from './Services/app.initial.service';
import { IktvaFormService } from './Services/app-iktvaForm.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormDialogComponent } from './formDialog/formDialog.component';
import { DataMigrationService } from './Services/dataMigration.service';
import { AboutComponent } from './about/app-about.component';
import { SuccessComponent } from './success/app-success.component';

import { OKTA_CONFIG, OktaAuthModule, OktaCallbackComponent, OktaAuthGuard } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AuthInterceptor } from './auth.interceptor';
import { environment } from '../environments/environment';
import { InitialDataResolver } from './Services/initial-data.resolver';

const oktaAuth = new OktaAuth({
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: environment.okta.redirectUri,
  postLogoutRedirectUri: environment.okta.postLogoutRedirectUri,
  scopes: environment.okta.scopes
});

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    FormDialogComponent,
    AboutComponent,
    SuccessComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: AboutComponent, pathMatch: 'full', canActivate: [OktaAuthGuard] },
      { path: 'implicit/callback', component: OktaCallbackComponent },
      { path: 'home', component: HomeComponent, canActivate: [OktaAuthGuard], resolve: { initialData: InitialDataResolver } },
      { path: 'announcements', component: CounterComponent, canActivate: [OktaAuthGuard] },
      { path: 'form', component: HomeComponent, canActivate: [OktaAuthGuard], resolve: { initialData: InitialDataResolver } },
      { path: 'contact', component: FetchDataComponent, canActivate: [OktaAuthGuard] },
      { path: 'success', component: SuccessComponent, canActivate: [OktaAuthGuard] }
    ]),
    OktaAuthModule,
    BrowserAnimationsModule,
    MatStepperModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatCardModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    NgxSpinnerModule,
    MatDialogModule,
    MatRadioModule,
    HttpClientModule
  ],
  providers: [
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    InitialService,
    IktvaFormService,
    DataMigrationService,
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
